@let hideUnmatchedFields_ = filteringFields() && hideUnmatchedFields();
@let hideUnmatchedFunctions_ = filteringFunctions() && hideUnmatchedFunctions();

<ng-template #dialogContent>
  <div class="expr-editor-dialog">
    <div class="top">
      <div class="header">
        <div class="left">
          <i class="fas fa-calculator i-16 mr-6"></i>
          <span>{{title()}}</span>
        </div>
        <div class="right">
          <button trgButton color="dialogClose" round
                  (click)="cancelClick()"
                  class="w-25 h-25">
            <i class="fal fa-times i-12"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="middle">
      <div class="details" [hidden]="!nameEditing() && !formatEditing()">
        <div class="format-grid">
          @if (nameEditing()) {
            <span class="grid-label user-select-none">
              <span class="c-red p-relative not-1">*</span>
              <strong>Name:</strong>
            </span>
            <input type="text"
                   [formControl]="name.control"
                   placeholder="Enter Name"
                   class="trg-outline fs-12 h-24"
                   style="width:  200px"
                   [readonly]="readonly() || disabled()"
                   required/>
          }

          @if (formatEditing()) {
            <span class="grid-label user-select-none">
              <strong>Format:</strong>
            </span>
            <mat-select class="trg-outline fs-12 h-24"
                        style="width:  120px"
                        panelClass="trg-outline-dropdown fs-12"
                        [(ngModel)]="format"
                        (ngModelChange)="runValidationDebounced()">
              <mat-select-trigger>
                @if (formatOption()) {
                  <span class="d-inline-block w-14 mr-4 text-center">
                    <i class="{{formatOption().icon}}"></i>
                  </span>
                  <span>{{formatOption().title}}</span>
                }
              </mat-select-trigger>
              @for (i of formatOptions; track i.value) {
                <mat-option [value]="i.value">
                  <span class="d-inline-block w-14 mr-4 text-center">
                    <i class="{{i.icon}}"></i>
                  </span>
                  <span>{{i.title}}</span>
                </mat-option>
              }
            </mat-select>
          }
        </div>
        
        <div [hidden]="!isNumericFormat()" class="format-grid ml-20">
          <span class="grid-label user-select-none">
            <strong>Rounding:</strong>
          </span>
          <mat-select class="trg-outline fs-12 h-24"
                      style="width: 135px"
                      panelClass="trg-outline-dropdown min-w-260 fs-12"
                      [(ngModel)]="numberRounding">
            <mat-select-trigger>
              @if (numberRoundingOption()) {
                <span>{{numberRoundingOption().title}}</span>
              }
            </mat-select-trigger>
            @for (i of numberRoundingOptions; track i.value) {
              <mat-option [value]="i.value">
                <span>{{i.title}}</span>
                <div class="option-help-text" [innerHTML]="i.helpText"></div>
              </mat-option>
            }
          </mat-select>

          <span class="grid-label user-select-none">
            <strong>Decimal Places:</strong>
          </span>
          <mat-select class="trg-outline fs-12 h-24"
                      style="width: 60px"
                      panelClass="trg-outline-dropdown fs-12"
                      [(ngModel)]="decimalPrecision">
            @for (i of decimalPrecisionOptions; track i) {
              <mat-option [value]="i">
                <span>{{i}}</span>
              </mat-option>
            }
          </mat-select>
        </div>
        
        <div [hidden]="!isNumericFormat()" class="format-grid ml-20">
          <span class="grid-label user-select-none">
            <strong>Show Group Separator:</strong>
          </span>
          <mat-select class="trg-outline fs-12 h-24"
                      style="width: 70px"
                      panelClass="trg-outline-dropdown min-w-260 fs-12"
                      [(ngModel)]="showThousandSeparator">
            <mat-select-trigger>
              @if (showThousandSeparatorOption()) {
                <span>{{showThousandSeparatorOption().title}}</span>
              }
            </mat-select-trigger>
            @for (i of showThousandSeparatorOptions; track i.value) {
              <mat-option [value]="i.value">
                <span>{{i.title}}</span>
                <div class="option-help-text" [innerHTML]="i.helpText"></div>
              </mat-option>
            }
          </mat-select>

          <span class="grid-label user-select-none">
            <strong>Significant Digits Only:</strong>
          </span>
          <mat-select class="trg-outline fs-12 h-24"
                      style="width: 70px"
                      panelClass="trg-outline-dropdown min-w-260 fs-12"
                      [(ngModel)]="significantDigitsOnly">
            <mat-select-trigger>
              @if (significantDigitsOnlyOption()) {
                <span>{{significantDigitsOnlyOption().title}}</span>
              }
            </mat-select-trigger>
            @for (i of significantDigitsOnlyOptions; track i.value) {
              <mat-option [value]="i.value">
                <span>{{i.title}}</span>
                <div class="option-help-text" [innerHTML]="i.helpText"></div>
              </mat-option>
            }
          </mat-select>
        </div>
        
        <div [hidden]="!isDateFormat() && !isTimeFormat()" class="format-grid ml-20">
          <div class="d-contents" [hidden]="!isDateFormat()">
            <span class="grid-label user-select-none">
              <strong>Date Format:</strong>
            </span>
            <mat-select class="trg-outline fs-12 h-24"
                        style="width: 120px"
                        panelClass="trg-outline-dropdown min-w-260 fs-12"
                        [(ngModel)]="dateFormat">
              <mat-select-trigger>
                @if (dateFormatOption()) {
                  <span>{{dateFormatOption().title}}</span>
                }
              </mat-select-trigger>
              @for (i of dateFormatOptions(); track i.value) {
                <mat-option [value]="i.value">
                  <span>{{i.title}}</span>
                  <div class="option-help-text" [innerHTML]="i.helpText"></div>
                </mat-option>
              }
            </mat-select>
          </div>

          <div class="d-contents" [hidden]="!isTimeFormat()">
            <span class="grid-label user-select-none">
              <strong>Time Format</strong>
            </span>
            <mat-select class="trg-outline fs-12 h-24"
                        style="width: 120px"
                        panelClass="trg-outline-dropdown min-w-260 fs-12"
                        [(ngModel)]="timeFormat">
              <mat-select-trigger>
                @if (timeFormatOption()) {
                  <span>{{timeFormatOption().title}}</span>
                }
              </mat-select-trigger>
              @for (i of timeFormatOptions(); track i.value) {
                <mat-option [value]="i.value">
                  <span>{{i.title}}</span>
                  <div class="option-help-text" [innerHTML]="i.helpText"></div>
                </mat-option>
              }
            </mat-select>
          </div>
        </div>
        
        <div class="format-grid ml-20">
          <div class="d-contents" [hidden]="!isCurrencyFormat()">
            <span class="grid-label user-select-none">
              <strong>Currency Display:</strong>
            </span>
            <mat-select class="trg-outline fs-12 h-24"
                        style="width: 90px"
                        panelClass="trg-outline-dropdown min-w-260 fs-12"
                        [ngModel]="currencyDisplayOption()"
                        (ngModelChange)="currencyDisplay.set($event.value)">
              <mat-select-trigger>
                @if (currencyDisplayOption()) {
                  <span>{{currencyDisplayOption().title}}</span>
                }
              </mat-select-trigger>
              @for (i of currencyDisplayOptions; track i) {
                <mat-option [value]="i">
                  <span>{{i.title}}</span>
                  <div class="option-help-text" [innerHTML]="i.helpText"></div>
                </mat-option>
              }
            </mat-select>
          </div>

          <span class="grid-label user-select-none"
                ngxTooltip
                [template]="nullTextTooltip">
            <strong>Null text:</strong>
            <i class="fas fa-info-circle fs-14 ml-4 c-blue p-relative ot-1"></i>
          </span>
          <input type="text"
                  placeholder="Enter Name"
                  class="trg-outline fs-12 h-24"
                  [(ngModel)]="nullText"
                  [disabled]="disabled()"
                  [readonly]="readonly()"
                  required />
        </div>
      </div>
      <div class="editor">
        <div class="fields" [hidden]="!displayFields()" >
          <div class="col-header">
            <strong>Field Selection:</strong>
          </div>
          <div class="col-body">
            <app-expr-editor-item-filter-component
              [anyExpanded]="anyFieldExpanded()"
              (toggleAll)="toggleAllFields()"
              (pattern)="fieldFilterPattern.set($event)"
              [(hideUnmatched)]="hideUnmatchedFields"></app-expr-editor-item-filter-component>

            <div class="field-list mt-8"
                 [class.hide-unmatched]="hideUnmatchedFields_"
                 [class.filtering]="filteringFields()">
              <div class="item-group-inner">
                @for (g of fieldItems().groups(); track g) {
                  <ng-container *ngTemplateOutlet="itemGroup; context: { g, itemTemplate: fieldItem, filtering: filteringFields, hideUnmatched: hideUnmatchedFields }"></ng-container>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="query">
          <div class="col-header">
            <strong>Query Editor:</strong>
          </div>
          <div class="col-body">
            <div class="editor-toolbar">
              <div class="left pl-4">
                <div class="editor-toolbar-btn" (click)="toolbarInsertClick('+')">
                  <span class="fs-18 p-relative ot-0">+</span>
                </div>
                <div class="editor-toolbar-btn" (click)="toolbarInsertClick('-')">
                  <span class="fs-18 p-relative not-1">-</span>
                </div>
                <div class="editor-toolbar-btn" (click)="toolbarInsertClick('*')">
                  <span class="fs-18 p-relative">*</span>
                </div>
                <div class="editor-toolbar-btn" (click)="toolbarInsertClick('/')">
                  <span class="fs-18 p-relative ot-0">/</span>
                </div>
                <div class="editor-toolbar-btn" (click)="toolbarInsertClick('(')">
                  <span class="fs-18">(</span>
                </div>
                <div class="editor-toolbar-btn" (click)="toolbarInsertClick(')')">
                  <span class="fs-18">)</span>
                </div>
                <div class="editor-toolbar-btn" (click)="toolbarInsertClick('&')">
                  <span class="fs-18">&amp;</span>
                </div>

                <div class="separator"></div>
                
                <div class="editor-toolbar-btn" (click)="undoClick()">
                  <i class="far fa-undo i-14 p-relative ot-1"></i>
                </div>
                <div class="editor-toolbar-btn" (click)="redoClick()">
                  <i class="far fa-redo i-14 p-relative ot-1"></i>
                </div>
                <div class="editor-toolbar-btn" (click)="cutClick()">
                  <i class="far fa-cut i-14 p-relative ot-1"></i>
                </div>
                <div class="editor-toolbar-btn" (click)="copyClick()">
                  <i class="far fa-copy i-14 p-relative ot-1"></i>
                </div>
                <div class="editor-toolbar-btn" (click)="pasteClick()">
                  <i class="far fa-paste i-14 p-relative ot-1"></i>
                </div>
              </div>
              <div class="right">
                <button trgButton color="white" class="fs-12 p-relative ot-1" (click)="clearAllClick()">
                  <span class="underline">Clear All</span>
                  <i class="fas fa-trash-alt ml-4 p-relative not-1 i-13" btnRight></i>
                </button>
              </div>
            </div>
            <div class="monaco-container">
              <div class="monaco-wrapper">
               <monaco-editor #monacoEditor
                  [config]="monacoConfig"
                  [completionItemProvider]="this"
                  [hoverProvider]="this"
                  (valueChange)="monacoValueChange()"></monaco-editor> 
              </div>
              <div class="editor-drop"
                   [class.visible]="dropping()"
                   trgDrop
                   [dropExpand]="[40, 40]"
                   (trgDropEnter)="onDragEnterDrop($event)"
                   (trgDropExit)="onDragExitDrop($event)"
                   (trgDropped)="onEditorDrop($event.data)"
                   [dropTags]="['exprEditorFieldDrop']">
              </div>
            </div>
            <div class="issues"
                 [class.expanded]="issuesExpanded() && visibleIssues().length" 
                 [class.has-errors]="anyErrors()">
              <div class="issues-title">
                <div>
                  <i class="fas {{anyErrors() ? 'fas fa-exclamation-triangle' : 'fa-check-circle'}} issue-icon w-18"></i>
                  <span [hidden]="anyErrors()">Syntax is valid</span>
                  <span [hidden]="!anyErrors()">Syntax errors have been detected</span>
                </div>
                <div>
                  <span [hidden]="!visibleIssues()?.length" class="underline pointer mr-2"
                        (click)="toggleIssues()">
                    {{issuesExpanded() ? 'Hide' : 'Show'}}
                  </span>
                </div>
              </div>
              <div class="issues-inner"
                   [style.min-height]="issuesExpanded() ? ((visibleIssues().length * 12) + 'px') : '0px'">
                @for (i of visibleIssues(); track $index) {
                  <div class="issue">
                    <span class="dot">•</span>
                    <span [innerHTML]="i.message"></span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="functions" [hidden]="!displayFunctions()">
          <div class="col-header">
            <strong>Functions:</strong>
          </div>
          <div class="col-body">
            <app-expr-editor-item-filter-component
              [showCollapseButton]="false"
              (pattern)="functionFilterPattern.set($event)"
              [(hideUnmatched)]="hideUnmatchedFunctions"></app-expr-editor-item-filter-component>
         
            <div class="field-list mt-8"
                 [class.hide-unmatched]="hideUnmatchedFunctions_"
                 [class.filtering]="filteringFunctions()">
              <div class="item-group-inner">
                @for (g of functionItems().groups(); track g) {
                  <ng-container *ngTemplateOutlet="itemGroup; context: { g, itemTemplate: funcItem, filtering: filteringFunctions, hideUnmatched: hideUnmatchedFunctions }"></ng-container>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom">
      <div class="left"></div>
      <div class="right">
        @if (!readonly()) {
        <button trgButton color="outline"
                (click)="cancelClick()"
                [disabled]="disabled()"
                class="min-w-80 mr-8">
          <span>Cancel</span>
        </button>

        <button trgButton color="primary"
                (click)="saveClick()"
                [disabled]="disabled()"
                class="min-w-80">
          <span>Save</span>
        </button>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #nullTextTooltip>
  <div class="trg-tooltip">
    <span>Text displayed when the underlying value is NULL.</span>
  </div>
</ng-template>

<ng-template #itemGroup let-g="g" let-itemTemplate="itemTemplate" let-filtering="filtering" let-hideUnmatched="hideUnmatched">
  @let visibleChildren = filtering() && hideUnmatched() ? g.filterMatchedVisibleChildrenCount() : g.children().length;
  @let visibleDescendants = filtering() && hideUnmatched() ? g.filterMatchedVisibleDescendantCount() : g.visibleDescendantCount();

  <div class="item-group"
       [class.collapsed]="g.collapsed()"
       [class.expanded]="!g.collapsed()"
       [class.item-group__no-children]="!visibleChildren"
       [class.pinned]="g.pinned()"
       [title]="g.longTitle()"
       style="--item-group-min-height: {{visibleDescendants * 26}}px;
              --item-group-max-height: {{visibleDescendants * 32 + 100}}px;">
    <div class="item-group-title">
      <div class="item-group-title-text">
        <strong>
          {{g.listTitle()}} ({{visibleChildren}})
        </strong>
      </div>
      <div>
        <span class="text-center pointer toggle-btn"
              (mousedown)="$event.stopPropagation()"
              (click)="g.toggleCollapsed()"
              [title]="g.collapsed() ? 'Expand' : 'Collapse'">
          <i [hidden]="g.collapsed()" class="fas fa-minus i-12 mr-4 ot-1 p-relative"></i>
          <i [hidden]="!g.collapsed()" class="fas fa-plus i-12 mr-4 ot-1 p-relative"></i>
        </span>
        <button trgButton color="white" class="w-14 h-20 ml-4 mr-2"
                (click)="g.togglePinned()"
                [title]="g.pinned() ? 'Unpin' : 'Pin'">
          <i class="{{g.pinned() ? 'fas' : 'far'
          }} fa-thumbtack i-11 p-relative ot-1"></i>
        </button>
      </div>
    </div>
    <div class="item-group-fields" [hidden]="!visibleChildren">
      @for (c of g.children(); track c) {
      <ng-container *ngTemplateOutlet="itemTemplate; context: { i: c }"></ng-container>
      }
    </div>
  </div>
</ng-template>

<ng-template #fieldItem let-i="i">
  <div class="item"
       [class.has-children]="!!i.children().length"
       [class.collapsed]="!!i.collapsed()"
       [class.expanded]="!i.collapsed()"
       [class.filter-match]="!!i.filterMatched()"
       [class.child]="!!i.parent"
       [title]="i.longTitle()"

       trgDrag
       #drag="TrgDragDirective"
       [canDrop]="true"
       [dragPreview]="fieldDragPreview"
       [dragPreviewSize]="sizing"
       [dragPreviewClass]="'app-expr-editor-item-drag-preview'"
       [dragData]="i"
       [dragDelay]="150"
       [dropTags]="['exprEditorFieldDrop']"
       #sizing
       
       (dblclick)="fieldDblClick($event, i)"
       (trgDragMove)="onDragMove($event, i)">
    <div class="item-left">
      <span class="item-icon lh-12">
        <i [class]="i.icon()"></i>
      </span>
      <span class="item-title">
        @if (!i.parent) {
          <text-highlight [text]="i.listTitle()"
                          [pattern]="fieldFilterPattern()"
                          (matched)="onItemFilterMatched(i, $event)"></text-highlight>
        }
        @else {
          <span>{{i.listTitle()}}</span>
        }
      </span>
    </div>
    <div class="item-right">
      @let t = i.target();
  
      <visual-editor-field-icons [field]="t">
        <ng-container beforeDataTypeIcon>
          @if (i.children().length) {
            <div class="pointer p-2 ml-4 mr-1"
                  (mousedown)="$event.stopPropagation()"
                  (click)="fieldItems().toggleCollapsed(i)">
              <i class="fas fa-chevron-up collapse-icon"
                 [attr.data-expanded]="!i.collapsed()"></i>
            </div>
          }
        </ng-container>
        <ng-container afterDataTypeIcon>
          @if (!i.parent) {
            <button trgButton color="white" class="w-18 h-20 pin-btn"
                    (mousedown)="$event.stopPropagation()"
                    (click)="fieldItems().togglePinned(i)"
                    [title]="i.pinned() ? 'Unpin' : 'Pin'">
              <i class="{{i.pinned() ? 'fas' : 'far'}} fa-thumbtack i-11 p-relative ot-1"></i>
            </button>
          }
        </ng-container>
      </visual-editor-field-icons>
    </div>
  </div>

  <div [hidden]="!i.children().length"
       class="item-child-fields"
       [class.parent-filter-match]="!!i.filterMatched()"
       [class.collapsed]="i.collapsed()"
       [class.expanded]="!i.collapsed()"
       style="--item-group-min-height: {{i.children().length * 26}}px;
              --item-group-max-height: {{i.children().length * 32 + 100}}px;">
    @for (c of i.children(); track c) {
      <ng-container *ngTemplateOutlet="fieldItem; context: { i: c }"></ng-container>
    }
  </div>
</ng-template>

<ng-template #fieldDragPreview let-dragData="dragData">
  @let i = dragData();

  <div class="item item-drag-preview">
    <div class="item-left">
      <span class="item-icon lh-12">
        <i [class]="i.icon()"></i>
      </span>
      <span class="item-title">
        <span>{{i.shortTitle()}}</span>
      </span>
    </div>
    <div class="item-right">
      @let t = i.target();
  
      <visual-editor-field-icons [field]="t">
      </visual-editor-field-icons>
    </div>
  </div>
</ng-template>

<ng-template #funcItem let-i="i">
  <div class="item"
       [class.filter-match]="!!i.filterMatched()"
       
       trgDrag
       #drag="TrgDragDirective"
       [canDrop]="true"
       [dragPreview]="funcDragPreview"
       [dragPreviewSize]="sizing"
       [dragPreviewClass]="'app-expr-editor-item-drag-preview'"
       [dragData]="i"
       [dragDelay]="150"
       [dropTags]="['exprEditorFieldDrop']"
       #sizing

       (dblclick)="fieldDblClick($event, i)">
    <div class="item-left">
      <span class="item-title" [title]="i.longTitle()">
        @if (!i.parent) {
          <text-highlight [text]="i.shortTitle()"
                          [pattern]="functionFilterPattern()"
                          (matched)="onItemFilterMatched(i, $event)"></text-highlight>
          <span class="func-arg-list">{{i.argumentListText()}}</span>
        }
        @else {
          <span>{{i.longTitle()}}</span>
        }
      </span>
    </div>
    <div class="item-right" ngxTooltip [template]="helpTooltip" title="">
      <i class="fas fa-info-circle pointer i-14 p-4 c-blue p-relative ot-1"></i>
      <ng-template #helpTooltip>
        <div class="trg-tooltip expr-editor-func-help-tooltip" [innerHTML]="i.descriptionHTML()">
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>
<ng-template #funcDragPreview let-dragData="dragData">
  @let i = dragData();
  <div class="item item-drag-preview">
    <div class="item-left">
      <span class="item-title">
        <span>{{i.shortTitle()
        }}</span>
        </span>
      </div>
    <div class="item-right">
    </div>
  </div>
</ng-template>
